import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xingternal/button';
import { ReportButton } from '@xingternal/pages-common';
import { Menu } from '@xingternal/menu';
import { List, ListItem } from '@xingternal/list';
import type { PopOverType } from '@xingternal/pop-over';

import styles from './styles.css';

type NewsItemMenuProps = {
  activityGlobalId: string;
  authorUrn: string;
  xbmUrl: string;
  popOver: PopOverType;
};

const NewsItemMenu = ({
  activityGlobalId,
  authorUrn,
  popOver,
  xbmUrl,
}: NewsItemMenuProps) => (
  <Menu
    onOutsideClick={popOver.handleHide}
    triggerRef={popOver.triggerRef}
    show={popOver.show}
  >
    <List>
      <ListItem skins={{ listItem: styles.listWrapper }}>
        <ReportButton
          className={styles.flyOutAction}
          targetUrn={activityGlobalId}
          authorUrn={authorUrn}
        >
          <FormattedMessage id="EP_REPORT_NEWS_ITEM" />
        </ReportButton>
      </ListItem>
      {xbmUrl && (
        <ListItem skins={{ listItem: styles.listWrapper }}>
          <TextButton
            size={'small'}
            href={xbmUrl}
            className={styles.flyOutAction}
            target={'_blank'}
            rel={'noreferrer noopener nofollow'}
            data-testid={'xbm-button'}
          >
            <FormattedMessage id="NEWS_MODULE_SHOW_STATISTICS" />
          </TextButton>
        </ListItem>
      )}
    </List>
  </Menu>
);

export { NewsItemMenu };
